import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.reflect.construct.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["backdrop", "backdropClosable", "animation", "show", "dialogComponentClass", "className", "clsPrefix", "style", "size", "width", "height", "children", "onEntering", "onExited", "backdropClassName", "containerClassName", "draggable", "resizeClassName", "bounds", "container", "onStart", "onStop", "bodyStyle", "zIndex", "destroyOnClose", "tempHide"];

var _dec, _class, _class2, _temp;

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classNames from 'classnames';
import events from 'dom-helpers/events';
import ownerDocument from 'dom-helpers/ownerDocument';
import canUseDOM from 'dom-helpers/util/inDOM';
import getScrollbarSize from 'dom-helpers/util/scrollbarSize';
import getScrollTop from 'dom-helpers/query/scrollTop';
import React, { cloneElement, Children } from 'react';
import { get } from "lodash-es";
import ReactDOM from 'react-dom';
import BaseModal from '../../wui-overlay/src/Modal';
import isOverflowing from '../../wui-overlay/src/utils/isOverflowing';
import { elementType, splitComponent, createChainedFunction } from '../../wui-core/src';
import { Fade } from '../../wui-transition/src';
import Body from './ModalBody';
import ModalDialog from './ModalDialog';
import Footer from './ModalFooter';
import Header from './ModalHeader';
import Title from './ModalTitle';
import Button from '../../wui-button/src';
import PropTypes from 'prop-types';
import { WebUI, prefix } from "../../wui-core/src/index.js";

var propTypes = _objectSpread(_objectSpread(_objectSpread({}, BaseModal.propTypes), ModalDialog.propTypes), {}, {
  /**
   * 是否弹出遮罩层/遮罩层点击是否触发关闭
   */
  backdrop: PropTypes.oneOf(['static', true, false]),

  /**
   * Modal body 样式
   */
  bodyStyle: PropTypes.object,

  /**
   * 关闭Modal之后销毁组件
   */
  destroyOnClose: PropTypes.object,

  /**
   * 可用于设置浮层的样式，调整浮层位置等
   */
  style: PropTypes.object,

  /**
   * 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
   */
  footer: PropTypes.element,

  /**
   * 是否显示右上角的关闭按钮
   */
  closable: PropTypes.bool,

  /**
   * 自定义关闭图标
   */
  closeIcon: PropTypes.element,

  /**
   * 标题
   */
  title: PropTypes.string,

  /**
   * 取消按钮属性
   */
  cancelButtonProps: PropTypes.object,

  /**
   * 取消按钮文字
   */
  cancelText: PropTypes.string,

  /**
   * 确认按钮属性
   */
  okButtonProps: PropTypes.object,

  /**
   * 确认按钮文字
   */
  okText: PropTypes.string,

  /**
   * 确认按钮colors类型
   */
  okType: PropTypes.string,

  /**
   * 设置z-index
   */
  zIndex: PropTypes.number,

  /**
   * 点击遮罩层是否允许关闭
   */
  backdropClosable: PropTypes.bool,

  /**
   * esc触发关闭
   */
  keyboard: PropTypes.bool,

  /**
   * 显隐时是否使用动画
   */
  animation: PropTypes.bool,

  /**
   * 传递给模态框的样式
   */
  dialogComponentClass: elementType,

  /**
   * 自动设置焦点
   */
  autoFocus: PropTypes.bool,

  /**
   * 防止打开时焦点离开模态框
   */
  enforceFocus: PropTypes.bool,

  /**
   * 是否打开模态框
   */
  show: PropTypes.bool,

  /**
   * 关闭时的钩子函数
   */
  onHide: PropTypes.func,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  containerClassName: PropTypes.string,

  /**
   * 要添加到的元素
   */
  container: BaseModal.propTypes.container,

  /**
   * 尺寸
   */
  size: PropTypes.oneOf(["sm", "md", "lg", ""]),

  /**
   * 自定义宽度
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * 自定义高度
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * 是否可拖拽
   */
  draggable: PropTypes.bool,

  /**
   * 是否可以resize
   */
  resizable: PropTypes.bool,
  resizeClassName: PropTypes.string,

  /* resize开始 */
  onResizeStart: PropTypes.func,

  /* resizing */
  onResize: PropTypes.func,

  /* resize结束 */
  onResizeStop: PropTypes.func,

  /* resize 最小宽度、最小高度、最大宽度、最大高度 */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bounds: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,

  /* 模态框是否居中显示 */
  centered: PropTypes.bool,
  needScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
});

var defaultProps = _objectSpread(_objectSpread({}, BaseModal.defaultProps), {}, {
  backdropClosable: false,
  animation: true,
  dialogComponentClass: ModalDialog,
  destroyOnClose: false,
  draggable: false,
  resizable: false,
  clsPrefix: "".concat(prefix, "-modal"),
  className: '',
  needScroll: false,
  bodyStyle: {},
  style: {},
  size: '',
  footer: undefined,
  enforceFocus: false,
  closable: true,
  closeIcon: null,
  title: '标题',
  zIndex: 1000,
  cancelButtonProps: {},
  cancelText: '取消',
  okButtonProps: {},
  okText: '确定',
  okType: 'primary',
  onOk: function onOk() {},
  onCancel: function onCancel() {}
});

var ModalFuncProps = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  show: PropTypes.bool,
  title: React.ReactNode,
  content: React.ReactNode,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  okText: PropTypes.string,
  okType: PropTypes.string,
  cancelText: PropTypes.string,
  icon: React.ReactNode,
  backdrop: PropTypes.oneOf(['static', true, false])
};

var ModalFunc = function ModalFunc(props) {
  var destroy = function destroy() {};

  var update = function update(newConfig) {};
};

export var destroyFns = [];
var childContextTypes = {
  $u_modal: PropTypes.shape({
    onHide: PropTypes.func
  })
};
var Modal = (_dec = WebUI({
  name: "modal",
  defaultProps: defaultProps
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props, context) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function () {
      var needScroll = _this.props.needScroll;

      if (needScroll) {
        if (typeof needScroll == 'number') {
          window.scrollTo(0, needScroll);
        } else {
          window.scrollTo(0, _this.scrollY);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEnter", function (param) {
      if (_this.props.needScroll) {
        _this.scrollY = window.scrollY;
      }

      _this.props.onEnter && _this.props.onEnter(param);
    });

    _defineProperty(_assertThisInitialized(_this), "onEntered", function (param) {
      if (_this.props.needScroll) {
        var scrollY = window.scrollY;

        if (scrollY != _this.scrollY || typeof _this.props.needScroll == 'number') {
          _this.scrollTo();
        }
      }

      _this.props.onEntered && _this.props.onEntered(param);
    });

    _defineProperty(_assertThisInitialized(_this), "clearCenteredCls", function () {
      var centered = _this.state.centered;

      if (!centered) {
        return;
      }

      _this.offsetTop = _this.getOffsetTop();

      _this.setState({
        centered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createHeader", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          _this$props$closable = _this$props.closable,
          closable = _this$props$closable === void 0 ? true : _this$props$closable,
          _this$props$closeIcon = _this$props.closeIcon,
          closeIcon = _this$props$closeIcon === void 0 ? null : _this$props$closeIcon,
          header = _this$props.header;
      if (header === null) return null;
      var renderCloseButton = closeIcon ? function () {
        return closeIcon;
      } : null;
      return /*#__PURE__*/React.createElement(Header, {
        closeButton: closable,
        renderCloseButton: renderCloseButton
      }, /*#__PURE__*/React.createElement(Title, null, title || '标题'));
    });

    _defineProperty(_assertThisInitialized(_this), "createBody", function (children) {
      var _this$props$bodyStyle = _this.props.bodyStyle,
          bodyStyle = _this$props$bodyStyle === void 0 ? {} : _this$props$bodyStyle;
      var bodyChildDom = children.filter(function (child) {
        // const clsPrefix = get(child, ['props', 'clsPrefix']) || ''
        var clsPrefix = child && child.props && child.props.clsPrefix ? child.props.clsPrefix : '';
        return !clsPrefix.includes('-header') && !clsPrefix.includes('-footer');
      }); // 如果children中含有不是header和footer的dom，而没有传Body组件，则这些非header和footer的dom结构，作为body

      return /*#__PURE__*/React.createElement(Body, {
        style: bodyStyle
      }, bodyChildDom);
    });

    _defineProperty(_assertThisInitialized(_this), "createFooter", function () {
      var _this$props2 = _this.props,
          cancelButtonProps = _this$props2.cancelButtonProps,
          cancelText = _this$props2.cancelText,
          okButtonProps = _this$props2.okButtonProps,
          okText = _this$props2.okText,
          okType = _this$props2.okType,
          onOk = _this$props2.onOk,
          onHide = _this$props2.onHide;

      var onOkCallback = function onOkCallback(event) {
        return onOk(event);
      };

      var onCancelCallback = function onCancelCallback(event) {
        return onHide(event);
      };

      return /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(Button, _extends({
        colors: "secondary",
        style: {
          marginRight: 8
        }
      }, cancelButtonProps, {
        onClick: onCancelCallback
      }), cancelText || '取消'), /*#__PURE__*/React.createElement(Button, _extends({
        colors: okType || 'primary'
      }, okButtonProps, {
        onClick: onOkCallback
      }), okText || '确认'));
    });

    _defineProperty(_assertThisInitialized(_this), "getDomNodeFromChildren", function (children, className) {
      return children.find(function (child) {
        // const clsPrefix = get(child, ['props', 'clsPrefix']) || ''
        var clsPrefix = child && child.props && child.props.clsPrefix ? child.props.clsPrefix : '';
        if (!clsPrefix) return false;
        return clsPrefix.includes(className);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createModalContent", function () {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // 优先渲染手动创建的Header，Body，Footer
      var footerProp = _this.props.footer;
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.getDomNodeFromChildren(children, '-header') || _this.createHeader(), _this.getDomNodeFromChildren(children, '-body') || _this.createBody(children), _this.getDomNodeFromChildren(children, '-footer') || (footerProp ? /*#__PURE__*/React.createElement(Footer, null, footerProp) : footerProp === null ? null : _this.createFooter()));
    });

    _this.state = {
      style: {},
      centered: props.centered,
      draging: false,
      draged: false,
      resized: false
    };
    _this.offsetTop = 0;
    _this.handleEntering = _this.handleEntering.bind(_assertThisInitialized(_this));
    _this.handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this.handleDialogClick = _this.handleDialogClick.bind(_assertThisInitialized(_this));
    _this.dialogMouseDownTarget = null;
    return _this;
  }

  _createClass(Modal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        $u_modal: {
          onHide: this.props.onHide
        }
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up the listener if we need to.
      this.handleExited();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.show) {
        // 关闭modal时，重置相关属性
        this.offsetTop = 0;
        this.setState({
          centered: nextProps.centered,
          resized: false
        });
      }
    }
  }, {
    key: "handleEntering",
    value: function handleEntering() {
      // FIXME: This should work even when animation is disabled.
      events.on(window, 'resize', this.handleWindowResize);
      this.updateStyle();
    }
  }, {
    key: "handleExited",
    value: function handleExited() {
      this.scrollTo();
      this.setState({
        draging: false,
        draged: false
      }); // FIXME: This should work even when animation is disabled.

      events.off(window, 'resize', this.handleWindowResize);
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.updateStyle();
    }
  }, {
    key: "handleDialogClick",
    value: function handleDialogClick(e) {
      if (e.target !== e.currentTarget || this.dialogMouseDownTarget && e.target !== this.dialogMouseDownTarget) {
        return;
      }

      this.props.onHide();
    }
  }, {
    key: "updateStyle",
    value: function updateStyle() {
      if (!canUseDOM || !this._modal) {
        return;
      }

      var dialogNode = this._modal.getDialogElement();

      var dialogHeight = dialogNode.scrollHeight;
      var document = ownerDocument(dialogNode);
      var bodyIsOverflowing = false;
      var container = this.props.container;

      if (container) {
        var containerDomNode = typeof container === 'function' ? container() : container;
        bodyIsOverflowing = isOverflowing(ReactDOM.findDOMNode(containerDomNode));
      }

      var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
      this.setState({
        style: {
          paddingRight: bodyIsOverflowing && !modalIsOverflowing ? getScrollbarSize() : undefined,
          paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? getScrollbarSize() : undefined
        }
      });
    } //ResizeStart 时，若模态框设置了 `centered` ，需要把居中属性移除，并通过 offsetTop 制造垂直居中的假象
    //fixbug: Resize 和 centered 一起使用时，拖拽交互不正确

  }, {
    key: "getOffsetTop",
    value: //计算 ModalDialog 的 offsetTop
    function getOffsetTop() {
      var modalDialog = document.getElementsByClassName("".concat(prefix, "-modal-dialog")) && document.getElementsByClassName("".concat(prefix, "-modal-dialog"))[0];
      var topPos = modalDialog && modalDialog.offsetTop;
      return topPos;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          backdrop = _this$props3.backdrop,
          backdropClosable = _this$props3.backdropClosable,
          animation = _this$props3.animation,
          show = _this$props3.show,
          Dialog = _this$props3.dialogComponentClass,
          className = _this$props3.className,
          clsPrefix = _this$props3.clsPrefix,
          _this$props3$style = _this$props3.style,
          style = _this$props3$style === void 0 ? {} : _this$props3$style,
          size = _this$props3.size,
          width = _this$props3.width,
          height = _this$props3.height,
          children = _this$props3.children,
          onEntering = _this$props3.onEntering,
          onExited = _this$props3.onExited,
          backdropClassName = _this$props3.backdropClassName,
          containerClassName = _this$props3.containerClassName,
          draggable = _this$props3.draggable,
          resizeClassName = _this$props3.resizeClassName,
          bounds = _this$props3.bounds,
          container = _this$props3.container,
          onStart = _this$props3.onStart,
          onStop = _this$props3.onStop,
          bodyStyle = _this$props3.bodyStyle,
          zIndex = _this$props3.zIndex,
          destroyOnClose = _this$props3.destroyOnClose,
          tempHide = _this$props3.tempHide,
          props = _objectWithoutProperties(_this$props3, _excluded);

      if (!show && destroyOnClose) return null;
      var _this$state = this.state,
          centered = _this$state.centered,
          draging = _this$state.draging,
          draged = _this$state.draged,
          resized = _this$state.resized;

      if (bodyStyle) {
        children = Children.map(children, function (child) {
          // const clsPrefix = get(child, ['props', 'clsPrefix'])
          var clsPrefix = child && child.props && child.props.clsPrefix ? child.props.clsPrefix : '';

          if (clsPrefix && clsPrefix.includes('-body')) {
            return /*#__PURE__*/cloneElement(child, {
              style: bodyStyle
            });
          }

          return child;
        });
      }

      var dialogMarginTop = 30; //ResizeStart 时，计算 ModalDialog 的 offsetTop

      var topPosStyle = this.offsetTop > 0 && !draging && !resized ? {
        top: this.offsetTop - dialogMarginTop
      } : null;
      var backdropStyle = {};

      if (zIndex) {
        backdropStyle.zIndex = zIndex;
      }

      var _splitComponent = splitComponent(props, BaseModal),
          _splitComponent2 = _slicedToArray(_splitComponent, 2),
          baseModalProps = _splitComponent2[0],
          dialogProps = _splitComponent2[1];

      var inClassName = show && !animation && 'in';

      var backdropClasses = _defineProperty({}, "".concat(clsPrefix, "-backdrop"), true);

      var containerClasses = _defineProperty({}, "".concat(clsPrefix, "-open"), true);

      if (!!centered) {
        className += " ".concat(clsPrefix, "-centered");
      }

      if (draging) {
        className += ' draging';
      }

      if (draged) {
        className += ' draged';
      }

      if (Number(width)) width += 'px';

      var styleRes = _objectSpread(_objectSpread(_objectSpread({}, this.state.style), style), topPosStyle);

      if (width) {
        Object.assign(styleRes, {
          width: width
        });
      }

      var contentStyle = height ? {
        height: height
      } : {}; // 目前给content的样式只有高度

      if (tempHide) {
        backdropStyle.display = 'none';
      } else {
        delete backdropStyle.display;
      }

      return /*#__PURE__*/React.createElement(BaseModal, _extends({}, baseModalProps, {
        ref: function ref(c) {
          _this2._modal = c;
        },
        show: show,
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: createChainedFunction(onEntering, this.handleEntering),
        onExited: createChainedFunction(onExited, this.handleExited),
        backdrop: backdrop,
        backdropClassName: classNames(backdropClasses, inClassName, backdropClassName),
        containerClassName: classNames(containerClasses, containerClassName),
        transition: animation ? Fade : undefined,
        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION,
        container: typeof container === 'function' ? container() : container,
        backdropStyle: backdropStyle
      }), /*#__PURE__*/React.createElement(Dialog, _extends({}, dialogProps, {
        style: styleRes,
        contentStyle: contentStyle,
        zIndex: zIndex,
        className: classNames(className, inClassName, backdropClassName),
        onClick: backdrop === true && !!backdropClosable ? this.handleDialogClick : null,
        onMouseDown: function onMouseDown(e) {
          return _this2.dialogMouseDownTarget = e.target;
        },
        size: size,
        tempHide: tempHide,
        draggable: draggable,
        bounds: bounds,
        resizeClassName: resizeClassName,
        clearCenteredCls: this.clearCenteredCls,
        onStart: function onStart() {
          _this2.setState({
            resized: true,
            draging: true,
            draged: false
          });
        },
        onStop: function onStop() {
          _this2.setState({
            draging: false,
            draged: true
          });
        }
      }), this.createModalContent(children)));
    }
  }]);

  return Modal;
}(React.Component), _defineProperty(_class2, "info", ModalFunc), _defineProperty(_class2, "success", ModalFunc), _defineProperty(_class2, "error", ModalFunc), _defineProperty(_class2, "warn", ModalFunc), _defineProperty(_class2, "warning", ModalFunc), _defineProperty(_class2, "confirm", ModalFunc), _defineProperty(_class2, "destroyAll", function () {
  return;
}), _temp)) || _class);
Modal.propTypes = propTypes;
Modal.childContextTypes = childContextTypes;
Modal.Body = Body;
Modal.Header = Header;
Modal.Title = Title;
Modal.Footer = Footer;
Modal.Dialog = ModalDialog;
Modal.TRANSITION_DURATION = 200000;
Modal.BACKDROP_TRANSITION_DURATION = 10000;
export default Modal;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/Modal.js